(function () {
  'use strict';

  /*  Extends modal service to prevent background navigation (e.g., browser back/forward)
   *  from severing the connection between the modal and its controller.
   */
  angular.module('ui.bootstrap.modal').config(['$provide', function ($provide) {
    $provide.decorator('$uibModal', ['$delegate', '$location', '$rootScope', function ($delegate, $location, $rootScope) {
      /*  Extend modal.open() to intercept the modalInstance returned by open().
       *  Use the modalInstance.opened and .result promises to determine if the modal
       *  has been opened or closed; use that information to disable location changes
       *  when the modal is open.
       */
      var _open = $delegate.open;
      $delegate.open = function (options) {
        // get modalInstance from the base open() method
        var modalInstance = _open(options);

        // use promise resolution to track if modal is being opened or closed.
        // when modalCount is incremented above 0, it disables location changes.
        // increment modalCount when the .opened promise is resolved (modal opened)
        modalInstance.opened.then(function () {
          $delegate.modalCount++;
        });
        // decrement modalCount when the .result promise is resolved (modal closed)
        modalInstance.result['finally'](function () {
          $delegate.modalCount--;
        });

        // return modalInstance to the caller, as expected.
        return modalInstance;
      };

      // prevent location changes when modalCount > 0 (a modal is open) - allows multiple modals
      $delegate.modalCount = 0;
      $delegate.locationFilter = $rootScope.$on('$locationChangeStart', function (event) {
        if ($delegate.modalCount) {
          event.preventDefault();
        }
      });
      return $delegate;
    }]);
  }]);
})();
